import React, { useEffect, useState } from 'react'
import "./Object.css";

export const Object = () => {
  const [hasIncremented, setHasIncremented] = useState(false);
  const page = "home";

  useEffect(() => {
    const fetchPageViews = async () => {
      try {
        const response = await fetch(`/api/pageView/${page}`);
        const data = await response.json();
      } catch (error) {
        console.error("Error fetching page view count:", error);
      }
    };

    const incrementPageView = async () => {
      try {
        await fetch(`/api/pageView/${page}/increment`, {
          method: 'POST',
        });
        setHasIncremented(true);
      } catch (error) {
        console.error("Error incrementing page view count:", error);
      }
    };

    if (!hasIncremented) {
      fetchPageViews();
      incrementPageView();
    } else {
      fetchPageViews();
    }
  }, [page, hasIncremented]);

  return (
    <div>
      <section className="py-1" id="features">
        <div className="container px-5 my-3">
          <div className="row gx-5">
            {/* <div className="col-lg-4 mb-5 mb-lg-0"><h2 className="fw-bolder mb-0">A better way to start building.</h2></div> */}
            <div className="">
              <div className="row gx-3 row-cols-1 row-cols-md-3">
                <div className="col mb-5 h-100 px-3">
                  <div className="premium-card h-100 text-center" style={{ padding: "2rem" }}>
                    <div className="feature rounded-3 mb-4 mx-auto" style={{ background: "rgba(56, 189, 248, 0.1)", width: "60px", height: "60px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(56, 189, 248, 0.3)", boxShadow: "0 0 15px rgba(56, 189, 248, 0.2)" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#38bdf8" viewBox="0 0 16 16">
                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
                      </svg>
                    </div>
                    <h2 className="h5 text-white fw-bolder mb-3" style={{ letterSpacing: "0.05em", textTransform: "uppercase" }}>Vision</h2>
                    <p className="mb-0 text-white" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                      Be the catalyst in creating the green society by the
                      way of developing applications and technologies, uplifting
                      lifestyle globally.
                    </p>
                  </div>
                </div>
                <div className="col mb-5 h-100 px-3">
                  <div className="premium-card h-100 text-center" style={{ padding: "2rem" }}>
                    <div className="feature rounded-3 mb-4 mx-auto" style={{ background: "rgba(56, 189, 248, 0.1)", width: "60px", height: "60px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(56, 189, 248, 0.3)", boxShadow: "0 0 15px rgba(56, 189, 248, 0.2)" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#38bdf8" viewBox="0 0 16 16">
                        <path d="M14.737 3.15 8.327 9.56a.5.5 0 0 1-.707-.708L14.029 2.43a1.5 1.5 0 0 0-2.12-2.12L5.493 6.726a4 4 0 0 0-1.077 1.93l-.407 1.838a1.5 1.5 0 0 0 1.868 1.867l1.838-.406a4 4 0 0 0 1.93-1.077L16.059 4.462a1.5 1.5 0 0 0-1.322-1.312"/>
                        <path d="M4.604 12.036 1.411 15.228a.5.5 0 1 1-.707-.707l3.192-3.193z"/>
                      </svg>
                    </div>
                    <h2 className="h5 text-white fw-bolder mb-3" style={{ letterSpacing: "0.05em", textTransform: "uppercase" }}>Mission</h2>
                    <p className="mb-0 text-white" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                      Building the incubation and accelerator ecosystem for
                      research & development by harnessing the best talents
                      through innovation and rapid adoption of technology
                      advancement to make a competitive edge in the market.
                    </p>
                  </div>
                </div>
                <div className="col mb-5 mb-md-0 h-100 px-3">
                  <div className="premium-card h-100 text-center" style={{ padding: "2rem" }}>
                    <div className="feature rounded-3 mb-4 mx-auto" style={{ background: "rgba(56, 189, 248, 0.1)", width: "60px", height: "60px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(56, 189, 248, 0.3)", boxShadow: "0 0 15px rgba(56, 189, 248, 0.2)" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#38bdf8" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.8 11.8 0 0 0 2.517 2.453c7.159 4.382 1.633-2.27 1.88-2.618a1.5 1.5 0 0 0-.012-1.74l-.946-1.12c-.22-.262-.572-.375-.89-.283a.47.47 0 0 1-.58-.39 8.7 8.7 0 0 1-.065-2.008C5.597 6.892 5.568 6.55 5.5 6.3c-.225-.828-1.085-.985-1.795-.658-1.533.708-3.32-.416-3.32-2.072 0-1.636 1.777-2.766 3.284-2.062.707.33 1.564.17 1.787-.66.07-.25.1-1.173.102-1.79l.002-1.06zm1.096 15.698C10.74 14.894 15 11.238 15 6V2.5L8 0 1 2.5V6c0 5.238 4.26 8.894 8.096 9.698zM5.5 11h5v1h-5zM5 8.5h6v1H5zM5 6h6v1H5z"/>
                      </svg>
                    </div>
                    <h2 className="h5 text-white fw-bolder mb-3" style={{ letterSpacing: "0.05em", textTransform: "uppercase" }}>Objectives</h2>
                    <p className="mb-0 text-white" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                      Enhance business value and revenue. Reduce inefficiencies and
                      leakages. Enhancing trust and openness. Reduce energy
                      consumption. Connect digitally.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
